import OrderTable from "@/components/OrderTable";
import { useNavigate } from "react-router-dom";
import { useOrdersContext } from "@/contexts/orders-context";
import { useAppState } from "@/contexts/app-state";
import Loader from "@components/Loader";
import { useOrders } from "@/hooks/use-orders";
import { useQueryKeys } from "@/hooks/use-query-keys";
import { useEffect } from "react";

const Admin = () => {
  const { filters, sortOrder, sortBy, setPageNumber } = useOrdersContext();
  const { currentUser, loggedInUser } = useAppState();
  const {
    isPending,
    data = { total: 0, rows: [], tabData: [], totalPages: 0, totalCount: 0 },
  } = useOrders({
    user: loggedInUser,
    filters,
    bucketName: currentUser,
    sortBy,
    sortOrder,
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (data === null) {
      navigate(`/error`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const getQueryKey = useQueryKeys("orders");
  useEffect(() => {
    setPageNumber(1);
  }, [currentUser, setPageNumber]);

  return (
    <Loader isLoading={isPending} displayText="Loading Available Orders...">
      <OrderTable
        totalPages={data.totalPages}
        totalItems={data.totalCount}
        rows={data.rows}
        tabs={data.tabData}
        ordersQueryKey={getQueryKey({
          user: loggedInUser,
          filters,
          bucketName: currentUser,
        })}
      />
    </Loader>
  );
};
export default Admin;
